import { Box, Button, Text } from 'grommet';
import { Trash } from 'grommet-icons';
import { observer } from 'mobx-react-lite';
import { useCommercialStore } from 'src/context';
import { getAnimProps } from 'src/utils/styling';
import { Divider } from '../Divider';
import { SaveStatus, SaveStatusIndicator } from '../SaveStatusIndicator';

export type EditsHeaderProps = {
  onCreateCommercial: () => void;
  onDeleteCommercials: () => void;
  hasSelectedCommercials?: boolean;
  height?: string;
};

export const EditsHeader = observer(
  ({ onCreateCommercial, onDeleteCommercials, hasSelectedCommercials, height = '92px' }: EditsHeaderProps) => {
    /** Context **/
    const commercialStore = useCommercialStore();

    /** Computed **/
    const saveStatus = commercialStore.isSaving ? SaveStatus.Saving : SaveStatus.Saved;

    /** Render **/
    return (
      <Box
        background="light-3"
        flex="grow"
        direction="row"
        align="center"
        justify="between"
        height={{
          min: height,
          max: height,
        }}
        gap="medium"
        style={{ zIndex: 1 }}
        elevation="small"
        pad={{ right: 'medium' }}
      >
        <Box direction="column" gap="xsmall">
          <Box
            margin={{ left: 'medium' }}
            animation={getAnimProps(0, 'slideUp')}
            justify="start"
            direction="row"
            pad={{ right: 'none' }}
          >
            <Text truncate size="xlarge">
              Commercial Edits
            </Text>
          </Box>
          <Divider height="2px" animation={{ type: 'slideRight', size: 'xlarge' }} />
          {saveStatus && (
            <Box align="end" animation={getAnimProps(0, 'slideDown')} pad={{ right: 'none' }}>
              <SaveStatusIndicator saveStatus={saveStatus} boxProps={{ margin: 'none' }} />
            </Box>
          )}
        </Box>

        <Box direction="row" gap="small" animation={{ type: 'slideLeft', size: 'large', duration: 500 }}>
          <Button
            onClick={onCreateCommercial}
            style={{
              fontSize: '0.9rem',
              fontWeight: 500,
            }}
            primary
            label="New Commercial"
          />
          <Button
            onClick={onDeleteCommercials}
            tip="Delete Selected Commercials"
            icon={<Trash color="red" />}
            disabled={!hasSelectedCommercials}
          />
        </Box>
      </Box>
    );
  }
);
